import { takeLatest, put } from 'redux-saga/effects'

import {
  SELECT_PROVIDER_CARE_POINT_UUID,
  SELECT_PROVIDER_DETAIL,
  REMOVE_SELECTED_PROVIDER_DETAIL,
  INCREAMENT_COUNT,
  SHUFFLE_SELECTED_PROVIDER_DETAIL,
  SELECT_PROVIDER_DETAIL_ASYNC,
  SHUFFLE_SELECT_PROVIDER_CARE_POINT_UUID,
  REMOVE_SELECTED_PROVIDER_DETAIL_ASYNC,
  SHUFFLE_SELECTED_PROVIDER_DETAIL_ASYNC,
  PROVIDER_SELECTION_LIMIT_REACHED_REMOVE,
} from '../constants/constant.action'

function* selectedMemberDetailSaga(action) {
  yield put({ type: SELECT_PROVIDER_DETAIL, payload: action.payload })
  yield put({ type: INCREAMENT_COUNT })
  yield put({
    type: SELECT_PROVIDER_CARE_POINT_UUID,
    payload: action.payload,
  })
}

function* removeSelectedMemberDetailSaga(action) {
  yield put({ type: REMOVE_SELECTED_PROVIDER_DETAIL, payload: action.payload })
  yield put({ type: PROVIDER_SELECTION_LIMIT_REACHED_REMOVE })
}

function* shufflingSelectedMemberDetailSaga(action) {
  yield put({
    type: SHUFFLE_SELECT_PROVIDER_CARE_POINT_UUID,
    payload: action.payload,
  })
  yield put({
    type: SHUFFLE_SELECTED_PROVIDER_DETAIL,
    payload: action.payload,
  })
}

export function* selectedMemberDetailWatcherSaga() {
  yield takeLatest(SELECT_PROVIDER_DETAIL_ASYNC, selectedMemberDetailSaga)
}

export function* removeSelectedMemberDetailWatcherSaga() {
  yield takeLatest(
    REMOVE_SELECTED_PROVIDER_DETAIL_ASYNC,
    removeSelectedMemberDetailSaga
  )
}

export function* shufflingSelectedMemberDetailWatcherSaga() {
  yield takeLatest(
    SHUFFLE_SELECTED_PROVIDER_DETAIL_ASYNC,
    shufflingSelectedMemberDetailSaga
  )
}
